// AP-165 · Kreyòl Ayisyen — admin ERP (dicionário base).
const ht = {
  app_name: "JMS ERP",
  loading: "N ap chaje…",
  save: "Anrejistre",
  cancel: "Anile",
  edit: "Modifye",
  delete: "Efase",
  add: "Ajoute",
  search: "Chèche",
  actions: "Aksyon",
  confirm_delete: "Èske w sèten ou vle efase?",
  yes: "Wi",
  no: "Non",
  optional: "opsyonèl",
  status: "Estati",
  active: "Aktif",
  inactive: "Inaktif",
  filter: "Filtre",
  clear: "Netwaye",
  all: "Tout",

  login_title: "Antre nan kont ou",
  login_subtitle: "Jere kliyan, sèvis ak peman san pwoblèm.",
  email: "Imèl",
  password: "Modpas",
  sign_in: "Konekte",
  signing_in: "N ap konekte…",
  invalid_credentials: "Imèl oswa modpas pa bon",
  logout: "Dekonekte",

  nav_dashboard: "Tablo",
  nav_customers: "Kliyan",
  nav_services: "Sèvis",
  nav_payments: "Peman",
  nav_balance: "Balans",
  nav_documents: "Dokiman",
  nav_appointments: "Randevou",
  nav_settings: "Paramèt",

  total_customers: "Total Kliyan",
  total_services: "Total Sèvis",
  total_payments: "Total Peman",
  outstanding_balance: "Balans ki rete",
  recent_payments: "Peman Resan",
  no_recent_payments: "Pa gen peman resan.",
  amount: "Montan",
  method: "Metòd",
  date: "Dat",

  customers_title: "Kliyan",
  customers_subtitle: "Jere kliyan ou yo ak enfòmasyon kontak.",
  full_name: "Non Konplè",
  phone: "Telefòn",
  whatsapp: "WhatsApp",
  address: "Adrès",
  notes: "Nòt",
  add_customer: "Nouvo Kliyan",
  edit_customer: "Modifye Kliyan",
  no_customers: "Pa gen kliyan ki anrejistre.",

  services_title: "Sèvis",
  services_subtitle: "Anrejistre sèvis konpayi ou ofri.",
  service_name: "Non Sèvis la",
  description: "Deskripsyon",
  price: "Pri",
  add_service: "Nouvo Sèvis",
  edit_service: "Modifye Sèvis",
  no_services: "Pa gen sèvis ki anrejistre.",

  payments_title: "Peman",
  payments_subtitle: "Anrejistre peman yo epi suiv balans ki rete.",
  customer: "Kliyan",
  service: "Sèvis",
  service_price: "Pri Sèvis",
  amount_paid: "Montan Peye",
  payment_date: "Dat Peman",
  payment_method: "Metòd Peman",
  remaining_balance: "Balans ki Rete",
  add_payment: "Nouvo Peman",
  edit_payment: "Modifye Peman",
  no_payments: "Pa gen peman anrejistre.",
  method_cash: "Lajan Kach",
  method_pix: "PIX",
  method_bank: "Vire",
  method_card: "Kat",
  select_customer: "Chwazi yon kliyan",
  select_service: "Chwazi yon sèvis",
  select_method: "Chwazi yon metòd",

  balance_title: "Balans",
  balance_subtitle: "Vizyon konplè sou peman ak balans pa kliyan ak sèvis.",
  total_price: "Pri Total",
  total_paid: "Total Peye",
  only_pending: "Sèlman sa ki an retà",
  no_balance: "Pa gen balans pou montre.",

  settings_title: "Paramèt",
  settings_subtitle: "Preferans konpayi a ak itilizatè a.",
  company_settings: "Konpayi",
  company_name: "Non Konpayi",
  company_logo: "URL Logo",
  currency: "Lajan",
  language: "Lang",
  user_profile: "Pwofil Itilizatè",
  name: "Non",
  current_password: "Modpas Aktyèl",
  new_password: "Nouvo Modpas",
  update_profile: "Mete Pwofil Ajou",
  update_company: "Mete Konpayi Ajou",
  saved_successfully: "Anrejistre ak siksè",

  created: "Kreye ak siksè",
  updated: "Mete ajou ak siksè",
  deleted: "Efase ak siksè",
  error_generic: "Yon erè pase. Eseye ankò.",

  // AP-165 Fase 2 · Services
  svc_pricing_type: "Tip Faktirasyon",
  svc_per_service: "Pou chak Sèvis",
  svc_per_unit: "Pou chak Inite",
  svc_per_time: "Pou chak Lè",
  svc_hint_per_unit: "Kliyan an achte plizyè inite (egz.: fotokopi, foto 3x4).",
  svc_hint_per_time: "Faktire pa dire (egz.: konsiltasyon pa èdtan).",
  svc_hint_per_service: "Pri fiks pa sèvis.",
  svc_unit_label: "Inite Mezi",
  svc_unit_ph_time: "Èdtan",
  svc_unit_ph_unit: "Paj, Kopi, Foto…",
  svc_price_per_unit: "Pri pa Inite",
  svc_price_per_hour: "Pri pa Èdtan",

  // AP-165 Fase 2 · Customers
  cus_view: "Wè:",
  cus_visible: "Vizib",
  cus_hidden: "Kache",
  cus_contact: "Kontak",
  cus_hidden_badge: "Kliyan Kache",
  cus_open: "Louvri",
  cus_show: "Montre kliyan",
  cus_hide: "Kache kliyan",
  cus_delete_title: "Efase Kliyan",
  cus_delete_desc_1: "Kliyan {name} ap retire nan lis prensipal la, men tout done li yo ap rete sove nan sistèm nan.",
  cus_delete_desc_2: "Master la kapab remèt li apati Poubèl la pita.",
  cus_delete_confirm_q: "Èske ou vle kontinye?",
  cus_attention: "ATANSYON",
  cus_show_title: "Montre Kliyan",
  cus_show_desc: "Èske ou vle retabli kliyan {name} nan je tout itilizatè ki otorize?",
  cus_hide_desc: "Èske ou vle kache kliyan {name}? Tout done yo ap rete sove. Kliyan an ap senpleman sispann parèt pou itilizatè nòmal yo.",
  cus_hide_reason_label: "Rezon (opsyonèl)",
  cus_hide_reason_ph: "Egz.: Kliyan archive, revizyon entèn…",
  cus_btn_show: "Montre",
  cus_btn_hide: "Kache",

  // AP-165 Fase 2 · Payments
  pay_combobox_placeholder: "Chèche pa non, CPF, WhatsApp, imèl, oswa dosye…",
  pay_combobox_search_ph: "Tape pou chèche…",
  pay_combobox_searching: "Ap chèche…",
  pay_combobox_empty: "Pa gen kliyan ki jwenn.",
  pay_discount_promocao_jms: "Promo JMS",
  pay_discount_desconto_comercial: "Rabè Komèsyal",
  pay_discount_cliente_fidelizado: "Kliyan Fidèl",
  pay_discount_ajuste_preco: "Ajisteman Pri",
  pay_discount_campanha_especial: "Kanpay Espesyal",
  pay_discount_outro: "Lòt",
};
export default ht;
